import { LogLevel, PublicClientApplication } from '@azure/msal-browser';
import b2cPolicies from './policies';
// Config object to be passed to Msal on creation

// console.info(`Setting the RedirectURI for the environment [${process.env.NODE_ENV}] to : [${process.env.VUE_APP_SPA_REDIRECT_URI}]`);
console.log(process.env)
export const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_AUTH_CLIENT_ID,
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    redirectUri: process.env.VUE_APP_SPA_REDIRECT_URI
  },
  cache: {
    cacheLocation: process.env.VUE_APP_APP_AUTH_STORAGE_TYPE, // Configures cache location.
    storeAuthStateInCookie: false // If you wish to store cache items in cookies as well as browser cache, set this to "true".
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
      logLevel: LogLevel.Verbose
    }
  }
};

export const msalInstance = new PublicClientApplication(msalConfig);

// The current application coordinates were pre-registered in a B2C tenant.
const apiConfig = {
  b2cScopes: [process.env.VUE_APP_MICROSOFT_AUTH_SCOPE_ENDPOINT]
};
// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
  scopes: ["openid", ...apiConfig.b2cScopes]
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me'
};
